import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../redux/hooks";
import { uiThunks } from "../../redux/ui/uiReducer";

export default function UserHasNoPersonPage() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const handleLogout = () => {
        // eslint-disable-next-line no-self-assign
        dispatch(uiThunks.logout({ reloadUrl: window.location.href }));
    };
    return (
        <Dialog open fullWidth maxWidth="xs">
            <DialogTitle>{t("missing-person-in-user")}</DialogTitle>
            <DialogContent>{t("missing-person-in-user-message")}</DialogContent>
            <DialogActions>
                <Button variant="text" onClick={handleLogout}>
                    {t("ok-button")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
